// recon-tax-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcs.payStatus.notApplicable': 'No aplica',
  'rcs.payStatus.paidLate': 'Pagada fuera de plazo',
  'rcs.payStatus.paidAfterPeriod': 'Pagada después del cierre del periodo',
  'rcs.payStatus.paid': 'Pagada',
  'rcs.payStatus.partial': 'Pagada parcialmente',
  'rcs.payStatus.overdue': 'Vencida: sin pagar',
  'rcs.payStatus.notDue': 'Aún no vencida',
  'rcs.payStatus.noFee': 'Sin cotización en el periodo',
  'rcs.bookStatus.notBooked': 'No contabilizada',
  'rcs.bookStatus.booked': 'Contabilizada',
  'rcs.bookStatus.difference': 'Diferencia contable',
  'rcs.bookStatus.ownTerm': 'Conciliada en su propio periodo',
  'rcs.bookStatus.onSubmit': 'Se liquida al presentar',
  'rcs.claimStatus.payrollRun': 'Calculada por la ejecución de nómina',
  'rcs.claimStatus.payrollSystem': 'Calculada por el sistema de nómina',
  'rcs.claimStatus.fixed': 'Fijada al presentar',
  'rcs.claimStatus.notFixed': 'No fijada',
  'rcs.reported.withholdingYes': 'Declarada en la a-melding',
  'rcs.reported.withholdingNo': 'Sin registro de declaración',
  'rcs.reported.vatSubmitted': 'Declaración de IVA presentada',
  'rcs.reported.vatDraft': 'Borrador: sin enviar',
  'rcs.claim.withholdingTitle': 'Retención a cuenta – {label}',
  'rcs.claim.runPeriod': 'nómina {period}',
  'rcs.claim.runDate': 'ejecución {date}',
  'rcs.claim.agaTitle': 'Cotización del empleador – periodo {term}',
  'rcs.claim.agaPeriod': 'Periodo {term} {year}',
  'rcs.claim.vatTitle': 'Impuesto sobre el valor añadido – periodo {n}',
  'rcs.payment.description': 'Pago {title}',
  'rcs.payment.directPosting': 'Asiento en cuenta de control',
  'rcs.vat.noTerm': 'No se ha encontrado ningún periodo',
  'rcs.source.ledger': 'Libro mayor',
  'rcs.source.payroll': 'Ejecuciones de nómina',
  'rcs.source.amelding': 'a-melding',
  'rcs.source.vat': 'Declaración de IVA del periodo',
  'rcs.source.payments': 'Pagos registrados de impuestos y tasas',
  'rcs.source.bank': 'Extracto bancario de los pagos',
  'rcs.source.skatteetaten': 'Resumen de obligaciones y saldo de Skatteetaten',
  'rcs.source.ledgerDetail': '{count} asientos en las cuentas de control en el periodo',
  'rcs.source.payrollDetailOne': '{count} ejecución contabilizada en el periodo',
  'rcs.source.payrollDetailMany': '{count} ejecuciones contabilizadas en el periodo',
  'rcs.source.payrollDetailNone': 'No hay ejecuciones de nómina contabilizadas en el periodo',
  'rcs.source.ameldingNone': 'No hay ejecuciones que declarar',
  'rcs.source.ameldingDetail': '{reported} de {total} ejecuciones constan como declaradas',
  'rcs.source.vatDetail': '{period} {year} · vencimiento {due}',
  'rcs.source.paymentsDetail': '{count} obligaciones tienen un pago registrado',
  'rcs.source.bankNone': 'Ningún extracto bancario cubre el periodo: los pagos no se pueden confirmar con el banco',
  'rcs.source.bankDetail': '{covered} de {total} pagos registrados están conciliados con un movimiento bancario',
  'rcs.source.skatteetatenDetail': 'Plumme no obtiene obligaciones, KID ni extractos de cuenta de Skatteetaten. Las obligaciones de abajo son las calculadas por la propia empresa, con vencimiento legal.',
  'rcs.check.accounts': 'Todas las cuentas de control relevantes están incluidas',
  'rcs.check.balance': 'El saldo contabilizado se ha comparado con las obligaciones calculadas',
  'rcs.check.withholdingPayroll': 'La retención a cuenta se ha comparado con la nómina y la a-melding',
  'rcs.check.withholdingPayments': 'La retención a cuenta se ha comprobado con los pagos registrados',
  'rcs.check.withholdingDeadlines': 'Los plazos de pago de la retención a cuenta se han comprobado',
  'rcs.check.aga': 'La cotización del empleador coincide con la base del sistema de nómina',
  'rcs.check.agaDeadline': 'El plazo de pago de la cotización del empleador se ha comprobado',
  'rcs.check.vat': 'La liquidación del IVA está vinculada a la conciliación de IVA',
  'rcs.check.partial': 'Las obligaciones pagadas parcialmente están identificadas',
  'rcs.check.bankCoverage': 'Los pagos registrados están confirmados con el extracto bancario',
  'rcs.check.bankCoverageNone': 'Los pagos registrados están confirmados con el extracto bancario (ningún extracto cubre el periodo)',
  'rcs.check.direct': 'Los asientos directos en las cuentas de control están identificados',
  'rcs.check.overdue': 'Las obligaciones públicas vencidas están identificadas',
  'rcs.check.unbooked': 'Todas las obligaciones están contabilizadas como deuda',
  'rcs.check.payrollBooked': 'Todas las ejecuciones de nómina del periodo están contabilizadas',
  'rcs.role.withholding': 'Retención a cuenta pendiente de pago al cierre del periodo',
  'rcs.role.garnishment': 'El modelo de nómina no calcula las retenciones por embargo',
  'rcs.role.aga': 'Cotización del empleador devengada y no pagada',
  'rcs.role.agaAccrued': 'Cotización devengada sobre la paga de vacaciones: se concilia en nómina',
  'rcs.role.vatSettlement': 'Declaración de IVA presentada y no liquidada',
  'rcs.role.taxPayable': 'Provisión contable: sin fuente externa',
  'rcs.role.deferredTax': 'Cálculo contable: sin fuente externa',
  'rcs.role.advanceTax': 'La aplicación no obtiene el aviso de anticipo',
  'rcs.role.publicFees': 'Otras tasas públicas: sin fuente externa',
  'rcs.role.addedByFirm': 'Añadida al área de impuestos por el despacho',
});
